// 3rd Party imports
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// Local imports
import Icons from "../../../../Config/Images";
import { getLoggedInUserDetailsAPI } from "../../../../Store/Action/UserAction";
import { getCartAPI } from "../../../../Store/Action/cartAction";
import "./OrderSummary.css";
import SelectAddressComponent from "../SelectAddress";

const OrderSummary = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.user);

  const [totalAmountData, setTotalAmountData] = useState(0);
  const [orderSummaryData, setOrderSummaryData] = useState([]);

  const handleBackClick = () => {
    navigate("/cart");
  };

  useEffect(() => {
    dispatch(
      getCartAPI({}, (result) => {
        setTotalAmountData(result?.total_amounts);
      })
    );

    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        setOrderSummaryData(result?.data?.[0]?.global_cart_info);
      })
    );
  }, [dispatch]);

  return (
    <>
      <div className="cart-heading">
        <div className="back-to-home">
          <img
            style={{ height: "30px", width: "30px" }}
            src={Icons.backArrowIcon}
            alt="Back"
            onClick={handleBackClick}
          />
          <h4>Back to Cart</h4>
        </div>
        <div className="heading-text">
          <h3>Order Summary</h3>
        </div>
      </div>
      <div className="order-summary-main-div">
        <div className="left-side-div">
          <div className="h3-heading">{/* <h3>Order Summary</h3> */}</div>
          {orderSummaryData?.map((e) => {
            return (
              <div className="individual-prod-div">
                <div className="metal-name">
                  <h3>{e?.product_metal_name} Products</h3>
                </div>
                <div className="inputs-div">
                  <div className="inp-label">
                    <p>Product Quantity</p>
                    <input
                      className="inp"
                      type="text"
                      value={e?.total_product_quantity}
                      readOnly
                    />
                  </div>
                  <div className="inp-label">
                    <p>Total Product Gross Weight</p>
                    <input
                      className="inp"
                      type="text"
                      value={e?.total_product_gross_weight}
                      readOnly
                    />
                  </div>
                  <div className="inp-label">
                    <p>All Product Net Weight</p>
                    <input
                      className="inp"
                      type="text"
                      value={e?.total_product_net_weight}
                      readOnly
                    />
                  </div>
                  <div className="inp-label">
                    <p>{e?.product_metal_name} Fine</p>
                    <input
                      className="inp"
                      type="text"
                      value={
                        userData?.user_role_id === 4
                          ? e?.product_retailer_per_pcs_fine
                          : e?.product_whole_seller_per_pcs_fine
                      }
                      readOnly
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="right-side-div">
          <div className="h3-heading">
            <h3>Total Summary</h3>
          </div>
          <div className="middle-div">
            <div className="charges">
              <p>Sub Total (Gold)</p>
              <span>{totalAmountData?.gold_total_amount}</span>
            </div>
            <div className="charges">
              <p>Sub Total (Silver)</p>
              <span>{totalAmountData?.silver_total_amount}</span>
            </div>
            <div className="charges">
              <p>Delivery Charge</p>
              <span>-</span>
            </div>
          </div>
          <div className="end-div">
            <div className="total">
              <p>Total</p>
              <span>{`${totalAmountData?.final_total_amount || 0}`}/-</span>
            </div>
            <div className="checkout-btn">
              <button>Process to Checkout</button>
            </div>
          </div>
        </div>
      </div>

      <div className="select-address-style">
        <SelectAddressComponent />
      </div>
    </>
  );
};

export default OrderSummary;
